import FeatureFlagInterfaceV1 from './FeatureFlagInterfaceV1';
import { IFeatureFlagService } from '../../../services/featureFlagService';
import { FeatureFlagClientInterfaceV1Type } from './types';
import { FeatureFlagInterfaceV1Type } from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

type CreateFeatureFlagInterfaceV1SingletonPropsType = {
  featureFlagService: IFeatureFlagService;
};

let featureFlagInterfaceV1: FeatureFlagInterfaceV1;

function _createFeatureFlagInterfaceV1(
  options: CreateFeatureFlagInterfaceV1SingletonPropsType
) {
  const { featureFlagService } = options;

  return new FeatureFlagInterfaceV1({
    featureFlagService
  });
}

export function getFeatureFlagInterfaceV1(): FeatureFlagInterfaceV1Type {
  return featureFlagInterfaceV1.getInterface();
}

export default async function initializeFeatureFlagInterfaceV1(
  options: CreateFeatureFlagInterfaceV1SingletonPropsType
): Promise<FeatureFlagInterfaceV1Type> {
  if (featureFlagInterfaceV1) return featureFlagInterfaceV1.getInterface();
  featureFlagInterfaceV1 = _createFeatureFlagInterfaceV1(options);

  return featureFlagInterfaceV1.getInterface();
}

/**
 * Create a bare-bones interface without any implementation. The term No-op
 * (NOP) stands for “no operation”.
 * @returns FeatureFlagInterfaceV1Type
 */
export function createNoopFeatureFlagsInterface(): FeatureFlagInterfaceV1Type {
  return {
    getClient: function (): Promise<FeatureFlagClientInterfaceV1Type> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopFeatureFlagsInterface',
        methodName: 'getClient()',
        message: 'Noop interface method called - returning null'
      });
      return Promise.resolve(null);
    },
    useReactFeatureFlag: function (): unknown {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopFeatureFlagsInterface',
        methodName: 'useReactFeatureFlag()',
        message: 'Noop interface method called - returning empty object'
      });
      return {};
    },
    createCustomClient: function (): Promise<FeatureFlagClientInterfaceV1Type> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopFeatureFlagsInterface',
        methodName: 'createCustomClient()',
        message: 'Noop interface method called - returning null'
      });
      return Promise.resolve(null);
    }
  };
}
